const isDebugEnabled = process.env.REACT_APP_DEBUG_LOGGING === 'true';

export const debug = {
  log: (...args: unknown[]) => {
    if (isDebugEnabled) {
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDebugEnabled) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};
